import { useEffect } from 'react';

// Extend the Window interface to include gtag
declare global {
    interface Window {
        gtag: (command: string, targetId: string, config?: any) => void;
    }
}

export const useGoogleAnalyticsConversion = (eventName: string, eventParameters?: any) => {
    useEffect(() => {
        // Check if gtag is available (Google Analytics is loaded)
        if (typeof window !== 'undefined' && window.gtag) {
            try {
                window.gtag('event', eventName, eventParameters || {});
            } catch (error) {
                console.error('Error triggering Google Analytics conversion event:', error);
            }
        } else {
            console.warn('Google Analytics (gtag) not available');
        }
    }, [eventName, eventParameters]);
};